/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {

    export class EmailConfigurationService extends services.DataService<Wars.Domain.Model.EmailConfiguration> {

        constructor(injectedBreeze: typeof breeze, $q: angular.IQService) {
            super(injectedBreeze, $q);
        }

        public getAllEmailConfigurationsByProcessId(processConfigId: string): ng.IPromise<Wars.Domain.Model.EmailConfiguration[]> {
            const query = this.breezeModule.EntityQuery
                .from("EmailConfigurations")
                .where('processConfiguration_id', '==', processConfigId)
                .expand('recipients.claim, carbonCopies, blindCarbonCopies')
                .orderBy("name");

            return this.executeQuery(query);
        }

        public getAllEmailConfigurations(): ng.IPromise<Wars.Domain.Model.EmailConfiguration[]> {
            const query = this.breezeModule.EntityQuery
                .from("EmailConfigurations")
                .expand('myProcessConfiguration, myProcessConfiguration.myProcessType')
                .orderBy("name");

            return this.executeQuery(query);
        }

        public createEmailConfiguration(): Wars.Domain.Model.EmailConfiguration {
            return <Wars.Domain.Model.EmailConfiguration>(this.createNewEntity("EmailConfiguration"));
        }
    }
}

warsApp.registerService('EmailConfigurationService', ['breeze', '$q']);